export enum OverlayRequestTypes {
  CreateUnnamedOverlayRequest = 'appbackend/CREATE_UNNAMED_OVERLAY_REQUEST',
  CreateUnnamedOverlaySuccess = 'appbackend/CREATE_UNNAMED_OVERLAY_SUCCESS',
  CreateUnnamedOverlayFailure = 'appbackend/CREATE_UNNAMED_OVERLAY_FAILURE',
  GetUnnamedOverlayRequest = 'appbackend/GET_UNNAMED_OVERLAY_REQUEST',
  GetUnnamedOverlaySuccess = 'appbackend/GET_UNNAMED_OVERLAY_SUCCESS',
  GetUnnamedOverlayFailure = 'appbackend/GET_UNNAMED_OVERLAY_FAILURE',
}
